import { z } from "zod";

const trimmedStringSchema = z.string().trim();

export function trimStringInput<T extends z.ZodString>(schema: T) {
  // A transform-first pipe exposes the validated schema to OpenAPI. Unlike
  // z.preprocess, the typed transform also preserves a string input for clients.
  return z
    .transform((value: string) => {
      const result = trimmedStringSchema.safeParse(value);
      return result.success ? result.data : value;
    })
    .pipe(schema);
}
